import styles from './MediaItem.module.scss';
import { Player } from 'ui/components/1-atoms/Media/Player/Player';
import { Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { useInView } from 'react-intersection-observer';

export interface MediaItemProps {
	className?: string;
	image?: {
		url: string;
		altText?: string;
		focalPoint?: { left: number; top: number };
		imageCropping?: 'cover' | 'contain';
	};
	video?: {
		url: string;
		poster?: string;
		autoplay?: boolean;
		showControls?: boolean;
	};
	sizes?: string;
}

export const MediaItem: React.FC<MediaItemProps> = ({ image, video, sizes }) => {
	const { ref, inView } = useInView({
		threshold: 0.5,
		triggerOnce: false,
	});
	return (
		<div ref={ref} className={styles.MediaItem}>
			{video ? (
				<Player
					url={video.url}
					isLight={video.autoplay || (inView && video.autoplay) ? false : true}
					playing={inView ? true : false}
					muted={true}
					loop={true}
					controls={video.showControls}
					poster={image?.url}
					cover={true}
				/>
			) : (
				image && (
					<Picture
						url={image.url}
						altText={image.altText}
						focalPoint={image.focalPoint}
						imageCropping={image.imageCropping ?? 'cover'}
						sizes={sizes}
					/>
				)
			)}
		</div>
	);
};
